module.exports = __webpack_public_path__ + "img/file_black.dbb9f26c.svg";